import wx from 'weixin-js-sdk' // 引入微信SDK
import { wxSign } from '@/api/index.js'

export default {
  // 注入
  initConfig (data){
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature,// 必填，签名
      jsApiList: ['checkJsApi',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'hideMenuItems',
      'showMenuItems',
      'hideAllNonBaseMenuItem',
      'showAllNonBaseMenuItem',
      'translateVoice',
      'startRecord',
      'stopRecord',
      'onVoiceRecordEnd',
      'playVoice',
      'onVoicePlayEnd',
      'pauseVoice',
      'stopVoice',
      'uploadVoice',
      'downloadVoice',
      'chooseImage',
      'previewImage',
      'uploadImage',
      'downloadImage',
      'getNetworkType',
      'openLocation',
      'getLocation',
      'hideOptionMenu',
      'showOptionMenu',
      'closeWindow',
      'scanQRCode',
      'chooseWXPay',
      'openProductSpecificView',
      'addCard',
      'chooseCard',
      'openCard',
      'updateAppMessageShareData',
      'updateTimelineShareData'
      ],// 必填，需要使用的JS接口列表
	  openTagList: [
		  'wx-open-launch-weapp'
	  ] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
    })
  },
  // 签名
  async initSign (url) {
    // let url=window.location.href
    // let url = location.href.split('#')[0]
    const { data: res } = await wxSign(url)
    this.initConfig(res.data)
  },
  initReady (shareParams) {
    wx.ready(function () {
      wx.updateAppMessageShareData({ 
        title: shareParams.title, // 分享标题
        desc: shareParams.desc, // 分享描述
        link: shareParams.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareParams.imgUrl, // 分享图标
        success: function () {
          // 设置成功
          // alert('分享到好友-设置成功')
        }
      });
      wx.updateTimelineShareData({ 
        title: shareParams.title, // 分享标题
        link: shareParams.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareParams.imgUrl, // 分享图标
        success: function () {
          // 设置成功
          // alert('分享到朋友圈-设置成功')
        }
      });
    })
  },
  isWeixin () {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true
    } else {
      return false
    }
  }
}